import { useEffect, useState } from 'react';

import services from 'services';

const useLanguage = () => {
  const [availableLanguages, setAvailableLanguages] = useState(services.appFrame.language.getAvailableLanguages);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(services.appFrame.language.getLanguage);
  useEffect(() => {
    const unsubscribeFromAvailableLanguagesChange = services.appFrame.language.onAvailableLanguagesChange(
      (newLanguages) => {
        setAvailableLanguages(newLanguages);
      },
    );
    const unsubscribeFromLanguagesChange = services.appFrame.language.onLanguageChange((newLanguage) => {
      setSelectedLanguage(newLanguage);
    });

    return () => {
      unsubscribeFromAvailableLanguagesChange();
      unsubscribeFromLanguagesChange();
    };
  }, []);

  return { availableLanguages, selectedLanguage };
};
export default useLanguage;
